module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29335",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9680",
      "ably-hubspot-js": "static-2.4728",
      "atom": "static-1.5084",
      "conversations-async-data": "static-2.7674",
      "conversations-error-reporting": "static-1.8897",
      "conversations-internal-pub-sub": "static-1.15989",
      "conversations-internal-schema": "static-1.12927",
      "conversations-message-history": "static-1.12737",
      "conversations-test-sdk": "static-1.10515",
      "conversations-visitor-experience-components": "static-1.22698",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5603",
      "hs-test-utils": "static-1.8025",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11483",
      "I18n": "static-7.1628",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3033",
      "jasmine-runner": "static-1.6476",
      "quartz": "static-1.7048",
      "react-dlb": "static-1.79",
      "react-select-plus": "static-1.105",
      "react-transition-group": "static-2.65",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4488",
      "StyleGuideUI": "static-3.487",
      "transmute": "static-2.85",
      "urlinator": "static-1.4548",
      "usage-tracker": "static-1.7355",
      "usage-tracker-core": "static-1.7205",
      "usage-tracker-public": "static-1.7166",
      "viral-links-lib": "static-1.7077",
      "visitor-ui-component-library": "static-1.6149",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4825",
      "conversations-prop-types": "static-1.7464",
      "conversations-visitor-message-history": "static-1.21435",
      "cssUtils": "static-1.794",
      "enviro": "static-4.455",
      "flux-actions": "static-1.338",
      "foundations-components": "static-1.7962",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6233",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.186",
      "react-aria": "static-1.66",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1-feat-id-1323-initial-url.10",
      "react-utils": "static-2.5352",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8153",
      "signup-constants": "static-1.18863",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5769",
      "visitor-ui-component-library-icons": "static-1.5960",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3406",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.86",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.82",
      "quartz-config": "static-1.826",
      "quartz-core": "static-1.6267",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4878",
      "foundations-theming": "static-1.4431",
      "UIComponents": "static-3.8429",
      "customer-data-email": "static-1.18058",
      "cv-backend-services": "static-1.1552",
      "immutable-less": "static-1.4665",
      "conversations-skeleton-state": "static-1.7258",
      "crm-events-viz-core": "static-1.33242",
      "customer-data-objects": "static-1.7681",
      "icons": "static-2.648",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4664",
      "ui-images": "static-2.1156",
      "HeadJS": "static-2.762",
      "framer-motion": "static-1.72",
      "hs-test-utils-bend-plugin": "static-1.3136",
      "msw": "static-1.39",
      "testing-library": "static-1.152",
      "i18n-data": "static-1.221",
      "moment-timezone": "static-5.83",
      "jasmine": "static-4.4339",
      "signup-ui-url-generator": "static-2.8063",
      "HubStyle": "static-2.11790",
      "quartz-i18n": "static-1.723",
      "sassPrefix": "static-1.156",
      "bend-plugin-foundations-components": "static-1.4231",
      "floating-ui": "static-1.56",
      "foundations-theming-specialty": "static-1.2147",
      "hs-story-utils": "static-1.9436",
      "react-create-root-preference": "static-1.26",
      "react-virtualized": "static-2.99",
      "tanstack-table": "static-1.55",
      "trellis-assets": "static-1.1982",
      "ui-fonts": "static-1.745",
      "hs-locale-management": "static-1.88",
      "csstype": "static-1.50",
      "quartz-head": "static-1.713",
      "quick-fetch": "static-1.3924",
      "web-vitals": "static-1.6",
      "quartz-routing": "static-1.478",
      "usage-tracker-anonymous": "static-1.5772",
      "bender-build-tools": "static-1.3205",
      "dispatcher": "static-1.136",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.836",
      "hubspotter-http": "static-1.4659",
      "mobile-manifest-mixins": "static-1.536",
      "module-federation": "static-1.23",
      "quartz-auth": "static-1.723",
      "quartz-test": "static-1.723",
      "quartz-tracking": "static-1.427",
      "usage-tracker-container": "static-1.7345",
      "bend-plugin-foundations-theming": "static-1.2914",
      "foundations-theming-base": "static-1.3416",
      "stylex": "static-1.33",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4663",
      "customer-data-ui-utilities": "static-1.9838",
      "FileManagerCore": "static-1.39166",
      "FileManagerLib": "static-1.39307",
      "hubspot-apollo-client": "static-1.4891",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.525",
      "timezone-utils": "static-2.5256",
      "ui-gdpr-components": "static-1.10362",
      "ts-schema": "static-1.4087",
      "ai-components-ui-library": "static-1.9020",
      "avatar-components": "static-1.2508",
      "content-assistance-lib": "static-1.7771",
      "crm-component-utils": "static-1.39121",
      "crm-display-components": "static-1.24871",
      "crm-fe-perf": "static-1.22914",
      "crm-links": "static-1.6305",
      "crm-message-bus": "static-1.43038",
      "crm-search-service-types": "static-1.1165",
      "crm-source-interpretation-lib": "static-1.5354",
      "customer-data-communicator": "static-1.45591",
      "customer-data-filters-ui": "static-1.39845",
      "customer-data-objects-ui-components": "static-1.13039",
      "customer-data-properties": "static-1.51604",
      "customer-data-rte": "static-1.33040",
      "draft-plugins": "static-2.21700",
      "file-manager-components": "static-1.23667",
      "framework-data-schema-resolvers": "static-1.6896",
      "frontend-preferences-client": "static-1.7939",
      "hubspot-prosemirror": "static-1.18274",
      "object-comments-thread-lib": "static-1.10704",
      "prosemirror-user-and-team-at-mentions": "static-1.625",
      "reference-resolvers-lite": "static-1.8106",
      "ui-addon-upgrades": "static-9.18013",
      "universal-associations-select": "static-1.11047",
      "universal-record-utils-lib": "static-1.941",
      "wootric-nps": "static-1.6986",
      "inbound-db-properties-service-client": "static-1.3853",
      "property-translator": "static-1.5412",
      "bend-plugin-chirp-manifest": "static-1.74",
      "chirp-fetch": "static-1.1899",
      "hub-http-shared-msw-handlers": "static-1.9998",
      "hubspotter-http-shared-msw-handlers": "static-1.9996",
      "usage-tracker-session-replay": "static-1.5041",
      "react-dnd-compat": "static-1.4626",
      "audio-components": "static-1.5933",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29318",
      "FileManagerImages": "static-1.36818",
      "foundations-components-legacy": "static-1.987",
      "immerable": "static-1.4166",
      "ui-universal-auth": "static-1.8992",
      "video-components": "static-1.13329",
      "video-data-lib": "static-1.34984",
      "video-embed": "static-1.35818",
      "hubspot-apollo-cache": "static-1.350",
      "chatspot-core": "static-1.21398",
      "ContentUtils": "static-1.68413",
      "copilot-toolkit": "static-1.11173",
      "superstore": "static-1.4773",
      "ui-addon-video-player": "static-1.8714",
      "ui-coaching-tips": "static-1.28607",
      "card-properties-lib": "static-1.44244",
      "commerce-subscription-lib": "static-1.37169",
      "crm-actions": "static-1.6337",
      "crm-cards-sdk": "static-1.43636",
      "customer-data-properties-shared-msw-handlers": "static-1.9325",
      "customer-data-property-utils": "static-1.8102",
      "customer-data-tracking": "static-1.6901",
      "hs-resources": "static-1.164",
      "inbound-db-meta-service-client": "static-1.3593",
      "pulse": "static-1.586",
      "framework-data-table": "static-2.11947",
      "location-customization-utils-lib": "static-1.9310",
      "restore-request-side-panel-lib": "static-1.919",
      "calling-error-reporting": "static-1.31321",
      "calling-internal-common": "static-1.31314",
      "calling-usage-tracker": "static-1.6553",
      "crm_data": "static-4.92016",
      "customer-data-content": "static-1.27312",
      "draft-content-plugins": "static-1.28312",
      "draft-convert": "static-2.73",
      "draft-extend": "static-3.75",
      "draft-js": "static-5.78",
      "draft-signature-plugin": "static-1.24114",
      "EmailSignatureEditor": "static-1.24402",
      "hubspot-prosemirror-plugins": "static-1.18266",
      "integration-settings-components": "static-1.15517",
      "integrations-lib": "static-1.16200",
      "integrations-tracking-lib": "static-1.5612",
      "native-integrations-shared-strings": "static-1.7793",
      "nav-meta": "static-1.29717",
      "onboarding-scopes": "static-1.6473",
      "outreach-assistant-email-generation": "static-1.6244",
      "prosemirror-copilot": "static-1.11660",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.38186",
      "react-colorpicker": "static-2.10218",
      "reference-resolvers": "static-1.8182",
      "rich-text-lib": "static-1.19857",
      "sales-email-signature-service-client": "static-1.3854",
      "sequences-lib": "static-1.8065",
      "ui-addon-i18n": "static-1.11160",
      "ui-addon-iframeable": "static-1.9069",
      "ui-business-units-lib": "static-1.9066",
      "ui-shepherd-react": "static-3.10176",
      "user-context": "static-1.5117",
      "whatsapp-sending-lib": "static-1.5740",
      "events-data-lib": "static-1.233",
      "customer-data-filters-ui-msw-helpers": "static-1.22280",
      "customer-data-reference-ui-components": "static-1.13176",
      "FormUrlGenerator": "static-2.4730",
      "framework-builder-read-service-client": "static-1.4012",
      "framework-data-schema-quick-fetch": "static-1.6801",
      "multi-account-reference-resolvers": "static-1.991",
      "onboarding-tours": "static-1.16638",
      "reporting-datasets-permissions-lib": "static-1.13731",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21571",
      "calling-global-api": "static-1.64562",
      "calling-lifecycle-internal": "static-1.65944",
      "calling-lifecycle-messages": "static-1.58238",
      "commerce-products-lib": "static-1.9623",
      "conditional-properties-service-client": "static-1.3804",
      "external-options-client-types": "static-1.4166",
      "google-libphonenumber": "static-1.38",
      "inbounddb-objects-service-types": "static-1.4230",
      "meetings-icalendar-utils-lib": "static-1.643",
      "multi-currency-client-types": "static-1.3698",
      "object-builder-ui-client": "static-1.48799",
      "pipeline-validation-client-types": "static-1.3972",
      "property-value-citations": "static-1.2218",
      "smart-property-lib": "static-1.7146",
      "tiered-pricing": "static-1.1249",
      "zustand": "static-1.74",
      "ui-addon-form-validation": "static-1.11001",
      "video-components-external": "static-1.11326",
      "batch-promise": "static-1.1553",
      "crm-pipelines-api-client-types": "static-1.4146",
      "fdsr-migration-layer": "static-1.15",
      "persist-promise": "static-1.3710",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25428",
      "knowledge-content-types": "static-1.8483",
      "payment-link-components": "static-1.23587",
      "ui-addon-emoji-picker": "static-1.9899",
      "call-summary": "static-1.39252",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10144",
      "laboratory-lib": "static-3.7167",
      "merchandise-lib": "static-1.264",
      "purchase-motions-components": "static-1.5927",
      "crm-object-search-query-utilities": "static-1.9603",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.788",
      "content-icons-ui": "static-1.2229",
      "social-insights-client-types": "static-1.22162",
      "outpost": "static-1.4193",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4824",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5559",
      "magpie-types": "static-1.5019",
      "simple-logging-lib": "static-1.3062",
      "growth-onboarding-feedback-components": "static-1.6592",
      "customer-data-sidebar": "static-2.46063",
      "enrichment-properties-lib": "static-1.16264",
      "ui-addon-draggable-compat": "static-2.4268",
      "commerce-billing-lib": "static-1.19121",
      "commerce-shared-components-lib": "static-1.18581",
      "commerce-tools-ui-lib": "static-1.10419",
      "bend-plugin-pulse": "static-1.89",
      "directed-graph": "static-1.947",
      "event-emitter": "static-1.959",
      "fast-json-patch": "static-1.63",
      "customer-data-associations": "static-1.7337",
      "reporting-data": "static-1.67612",
      "tanstack-virtual": "static-1.30",
      "ui-addon-draggable": "static-3.4774",
      "crm-record-cards-service-types": "static-1.3604",
      "self-service-api": "static-1.10259",
      "crm_universal": "static-1.22031",
      "SalesContentIndexUI": "static-3.9268",
      "content-embed-lib": "static-1.7350",
      "data-model-builder-lib": "static-1.12399",
      "remote-ui": "static-1.65",
      "ui-components-test-utils": "static-1.5620",
      "ui-extensions-remote-renderer": "static-1.17052",
      "universal-page-editor-lib": "static-1.3024",
      "integrations-error-boundary-lib": "static-1.13615",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10377",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.506",
      "messaging-types-lib": "static-1.46062",
      "ai-addon-copilot-preview": "static-1.8232",
      "copilot-plugins": "static-1.11146",
      "data-token-picker": "static-1.16431",
      "sequences-client-types-lib": "static-1.7922",
      "foundations-components-test-utils": "static-1.5445",
      "navigation-messaging": "static-1.7407",
      "getting-started-shared-tasks": "static-1.18507",
      "getting-started-shared-tasks-store": "static-1.17625",
      "onboarding-tours-utils": "static-1.704",
      "messaging-usage-based-billing-components-lib": "static-1.1187",
      "whatsapp-management-lib": "static-1.8899",
      "growth-data-modal": "static-1.5448",
      "growth-onboarding-confetti": "static-1.3078",
      "growth-onboarding-next-action-utils": "static-1.1968",
      "navigation-components": "static-1.18080",
      "onboarding-tours-client": "static-1.4852",
      "ui-shepherd-tracker": "static-1.7557",
      "shared-worker-versioning": "static-1.11048",
      "voice-sms-access-library": "static-1.1025",
      "commerce-permissions": "static-1.781",
      "products-iframe-lib": "static-1.7982",
      "products-ui-components-shared-msw-handlers": "static-1.10380",
      "data-agent-kit": "static-1.213",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10081",
      "fsm": "static-1.3742",
      "policy-lib": "static-1.6789",
      "react-tinymce": "static-1.55289",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54415",
      "tinymce-plugins": "static-1.57529",
      "tinymce-themes": "static-1.56385",
      "content-media-composition-data-lib": "static-1.12369",
      "content-media-compositions": "static-2.16376",
      "idb-keyval": "static-1.44",
      "media-bridge-lib": "static-1.18950",
      "seat-types-lib": "static-1.46",
      "ui-addon-opt": "static-4.8378",
      "commerce-tours-lib": "static-1.6127",
      "growth-onboarding-reliability": "static-1.5094",
      "sales-checkout-service-client": "static-1.3652",
      "calling-cross-tab-library": "static-1.19298",
      "calling-lifecycle-usage-tracker": "static-1.8747",
      "purchase-motions-api": "static-1.5930",
      "trials-service-types": "static-1.3914",
      "reactive-lib": "static-1.736",
      "card-payment-highlight-lib": "static-1.37223",
      "card-subscription-highlight-lib": "static-1.39592",
      "commerce-contract-lib": "static-1.12112",
      "invoices-highlight-card-lib": "static-1.54779",
      "orders-highlight-card-lib": "static-1.21516",
      "products-highlight-card-lib": "static-1.17906",
      "quotes-highlight-card-lib": "static-1.72096",
      "usage-based-billing-components-lib": "static-1.8962",
      "utility-belt": "static-1.2546",
      "payments-enrollment-embed-lib": "static-1.22945",
      "stripe-embedded-components": "static-1.7529",
      "growth-onboarding-empty-states": "static-1.5755",
      "InboxConnectUtils": "static-4.14859",
      "payments-post-enroll-local-storage-lib": "static-1.5120",
      "qrcode-generator": "static-1.69",
      "reporting-client-types": "static-1.2499",
      "react-flip-move": "static-1.70",
      "FireAlarmUi": "static-1.4520",
      "sales-templates-service-types-lib": "static-1.4177",
      "ui-asset-management-lib": "static-1.11051",
      "association-settings-lib": "static-1.10330",
      "collaboration-sidebar": "static-1.57872",
      "conditional-property-settings-modal": "static-1.12478",
      "data-model-commons-lib": "static-1.12659",
      "ExportDialog": "static-6.10399",
      "final-form": "static-1.70",
      "html-to-image": "static-1.54",
      "nudge-client-utils": "static-1.2613",
      "object-definition-builder-lib": "static-1.7113",
      "property-management-iframe": "static-1.13206",
      "property-usages-lib": "static-1.5451",
      "reactflow": "static-1.64",
      "simple-data-table": "static-1.2827",
      "used-in-list-lib": "static-1.6968",
      "visual-association": "static-1.5894",
      "highcharts": "static-8.104",
      "reporting-visualizations": "static-1.59688",
      "ui-extensibility-client-types": "static-1.3935",
      "google-sheets-integration-lib": "static-1.288",
      "microsoft-drive-integration-lib": "static-1.413",
      "slack-ui-library": "static-1.10404",
      "automation-platform-service-types": "static-1.2593",
      "ContentData": "static-1.68488",
      "email-portal-health-service-types": "static-1.989",
      "marketing-email-service-types": "static-1.1919",
      "ai-rendering-library": "static-1.10231",
      "ai-settings-ui-library": "static-1.7905",
      "breeze-engine-lib": "static-1.703",
      "ui-brand-identity-lib": "static-1.15332",
      "messaging-shared-utils-lib": "static-1.636",
      "messaging-user-info-utils-lib": "static-1.806",
      "content-whatsapp-service-types": "static-1.387",
      "marketing-platform-lib": "static-1.6869",
      "short-messages-app-service-client": "static-1.3979",
      "ui-tool-access": "static-1.10159",
      "onboarding-data-sync-lib": "static-1.1977",
      "growth-onboarding-next-action-components": "static-1.1996",
      "user-context-client": "static-1.4624",
      "nest": "static-1.239",
      "calling-orchestration-schema": "static-1.35802",
      "sales-views-client-types": "static-1.4270",
      "trellis-story-utils": "static-1.4527",
      "storybook-react": "static-1.33",
      "hub-http-contrib": "static-1.3054",
      "interframe": "static-3.4771",
      "tinymce-data": "static-1.40500",
      "ui-addon-sales-email": "static-1.5222",
      "codemirror": "static-5.95",
      "layout-dnd-components": "static-1.12470",
      "layout-dnd-utils": "static-1.11445",
      "react-codemirror": "static-1.10638",
      "NamespacedHubStyle": "static-2.9066",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40141",
      "accounting-integrations-ui-components": "static-1.7086",
      "invoices-ui-lib": "static-1.54795",
      "commerce-products-api": "static-1.2314",
      "invoices-iframe-lib": "static-1.56853",
      "quotes-modal-lib": "static-1.102774",
      "quotes-ui-lib": "static-1.80817",
      "platform-infra-nav-components": "static-1.7677",
      "reporting-ui-components": "static-2.64883",
      "subscription-experience-data-types": "static-1.14950",
      "marketplace-ui-apps-core": "static-1.18302",
      "stripe-connect-js": "static-1.69",
      "ui-addon-react-router-dom": "static-1.9553",
      "nested-table": "static-1.238",
      "chatspot-widget-iframe": "static-1.21389",
      "collaboration-sidebar-common": "static-1.2669",
      "crm-properties-common-lib": "static-1.5896",
      "nudge-custom-function-registry": "static-1.2370",
      "nudge-renderer-utils": "static-1.2689",
      "whisper-core-api": "static-1.6669",
      "property-management-common": "static-1.5494",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15147",
      "advanced-menus-lib": "static-1.12086",
      "ui-memberships-settings-lib": "static-1.34093",
      "breeze-onboarding-components": "static-1.60",
      "embedded-academy-lib": "static-1.14392",
      "highlight.js": "static-1.79",
      "reporting-action-components": "static-1.41345",
      "reporting-snowflake": "static-1.56230",
      "meetings-connect-utils-lib": "static-1.7617",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9770",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.538",
      "price-books-api": "static-1.798",
      "price-books-components": "static-1.856",
      "property-description-translator": "static-1.3856",
      "ramp-editor": "static-1.183",
      "commerce-analytics-service-client": "static-1.3640",
      "totals-ui-components": "static-1.23646",
      "reporting-plugins": "static-1.10343",
      "reporting-reports": "static-1.67290",
      "edison-service-client-types": "static-1.399",
      "developer-experience-shared-components": "static-1.10521",
      "marketplace-ui-client-types": "static-1.17176",
      "marketplace-ui-common": "static-1.19769",
      "ui-addon-integrations-directory-panel": "static-2.8010",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.184",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15146",
      "simple-menus-lib": "static-1.16663",
      "academy-common-lib": "static-1.13852",
      "dashboard-lib": "static-1.81590",
      "share-with-third-party-component-lib": "static-1.8713",
      "line-items-api": "static-1.714",
      "commerce-totals-service-types": "static-1.3826",
      "campaign-roi-lib": "static-1.9167",
      "apps-service-types": "static-1.3889",
      "oauth-service-types": "static-1.4260",
      "academy-service-client": "static-1.3692",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7162",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29335",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9680",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4728",
      "atom": "/atom/static-1.5084",
      "conversations-async-data": "/conversations-async-data/static-2.7674",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8897",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15989",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12927",
      "conversations-message-history": "/conversations-message-history/static-1.12737",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10515",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22698",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5603",
      "hs-test-utils": "/hs-test-utils/static-1.8025",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11483",
      "I18n": "/I18n/static-7.1628",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3033",
      "jasmine-runner": "/jasmine-runner/static-1.6476",
      "quartz": "/quartz/static-1.7048",
      "react-dlb": "/react-dlb/static-1.79",
      "react-select-plus": "/react-select-plus/static-1.105",
      "react-transition-group": "/react-transition-group/static-2.65",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4488",
      "StyleGuideUI": "/StyleGuideUI/static-3.487",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4548",
      "usage-tracker": "/usage-tracker/static-1.7355",
      "usage-tracker-core": "/usage-tracker-core/static-1.7205",
      "usage-tracker-public": "/usage-tracker-public/static-1.7166",
      "viral-links-lib": "/viral-links-lib/static-1.7077",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6149",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4825",
      "conversations-prop-types": "/conversations-prop-types/static-1.7464",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21435",
      "cssUtils": "/cssUtils/static-1.794",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.338",
      "foundations-components": "/foundations-components/static-1.7962",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6233",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.186",
      "react-aria": "/react-aria/static-1.66",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1-feat-id-1323-initial-url.10",
      "react-utils": "/react-utils/static-2.5352",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8153",
      "signup-constants": "/signup-constants/static-1.18863",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5769",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5960",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3406",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.82",
      "quartz-config": "/quartz-config/static-1.826",
      "quartz-core": "/quartz-core/static-1.6267",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4878",
      "foundations-theming": "/foundations-theming/static-1.4431",
      "UIComponents": "/UIComponents/static-3.8429",
      "customer-data-email": "/customer-data-email/static-1.18058",
      "cv-backend-services": "/cv-backend-services/static-1.1552",
      "immutable-less": "/immutable-less/static-1.4665",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7258",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33242",
      "customer-data-objects": "/customer-data-objects/static-1.7681",
      "icons": "/icons/static-2.648",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4664",
      "ui-images": "/ui-images/static-2.1156",
      "HeadJS": "/HeadJS/static-2.762",
      "framer-motion": "/framer-motion/static-1.72",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3136",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.152",
      "i18n-data": "/i18n-data/static-1.221",
      "moment-timezone": "/moment-timezone/static-5.83",
      "jasmine": "/jasmine/static-4.4339",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8063",
      "HubStyle": "/HubStyle/static-2.11790",
      "quartz-i18n": "/quartz-i18n/static-1.723",
      "sassPrefix": "/sassPrefix/static-1.156",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4231",
      "floating-ui": "/floating-ui/static-1.56",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2147",
      "hs-story-utils": "/hs-story-utils/static-1.9436",
      "react-create-root-preference": "/react-create-root-preference/static-1.26",
      "react-virtualized": "/react-virtualized/static-2.99",
      "tanstack-table": "/tanstack-table/static-1.55",
      "trellis-assets": "/trellis-assets/static-1.1982",
      "ui-fonts": "/ui-fonts/static-1.745",
      "hs-locale-management": "/hs-locale-management/static-1.88",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.713",
      "quick-fetch": "/quick-fetch/static-1.3924",
      "web-vitals": "/web-vitals/static-1.6",
      "quartz-routing": "/quartz-routing/static-1.478",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5772",
      "bender-build-tools": "/bender-build-tools/static-1.3205",
      "dispatcher": "/dispatcher/static-1.136",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.836",
      "hubspotter-http": "/hubspotter-http/static-1.4659",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
      "module-federation": "/module-federation/static-1.23",
      "quartz-auth": "/quartz-auth/static-1.723",
      "quartz-test": "/quartz-test/static-1.723",
      "quartz-tracking": "/quartz-tracking/static-1.427",
      "usage-tracker-container": "/usage-tracker-container/static-1.7345",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2914",
      "foundations-theming-base": "/foundations-theming-base/static-1.3416",
      "stylex": "/stylex/static-1.33",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4663",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9838",
      "FileManagerCore": "/FileManagerCore/static-1.39166",
      "FileManagerLib": "/FileManagerLib/static-1.39307",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4891",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.525",
      "timezone-utils": "/timezone-utils/static-2.5256",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10362",
      "ts-schema": "/ts-schema/static-1.4087",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9020",
      "avatar-components": "/avatar-components/static-1.2508",
      "content-assistance-lib": "/content-assistance-lib/static-1.7771",
      "crm-component-utils": "/crm-component-utils/static-1.39121",
      "crm-display-components": "/crm-display-components/static-1.24871",
      "crm-fe-perf": "/crm-fe-perf/static-1.22914",
      "crm-links": "/crm-links/static-1.6305",
      "crm-message-bus": "/crm-message-bus/static-1.43038",
      "crm-search-service-types": "/crm-search-service-types/static-1.1165",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5354",
      "customer-data-communicator": "/customer-data-communicator/static-1.45591",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39845",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13039",
      "customer-data-properties": "/customer-data-properties/static-1.51604",
      "customer-data-rte": "/customer-data-rte/static-1.33040",
      "draft-plugins": "/draft-plugins/static-2.21700",
      "file-manager-components": "/file-manager-components/static-1.23667",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6896",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7939",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18274",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10704",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.625",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8106",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18013",
      "universal-associations-select": "/universal-associations-select/static-1.11047",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.941",
      "wootric-nps": "/wootric-nps/static-1.6986",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3853",
      "property-translator": "/property-translator/static-1.5412",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.74",
      "chirp-fetch": "/chirp-fetch/static-1.1899",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9998",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9996",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5041",
      "react-dnd-compat": "/react-dnd-compat/static-1.4626",
      "audio-components": "/audio-components/static-1.5933",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29318",
      "FileManagerImages": "/FileManagerImages/static-1.36818",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.987",
      "immerable": "/immerable/static-1.4166",
      "ui-universal-auth": "/ui-universal-auth/static-1.8992",
      "video-components": "/video-components/static-1.13329",
      "video-data-lib": "/video-data-lib/static-1.34984",
      "video-embed": "/video-embed/static-1.35818",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.350",
      "chatspot-core": "/chatspot-core/static-1.21398",
      "ContentUtils": "/ContentUtils/static-1.68413",
      "copilot-toolkit": "/copilot-toolkit/static-1.11173",
      "superstore": "/superstore/static-1.4773",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8714",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28607",
      "card-properties-lib": "/card-properties-lib/static-1.44244",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37169",
      "crm-actions": "/crm-actions/static-1.6337",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43636",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9325",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8102",
      "customer-data-tracking": "/customer-data-tracking/static-1.6901",
      "hs-resources": "/hs-resources/static-1.164",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3593",
      "pulse": "/pulse/static-1.586",
      "framework-data-table": "/framework-data-table/static-2.11947",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9310",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.919",
      "calling-error-reporting": "/calling-error-reporting/static-1.31321",
      "calling-internal-common": "/calling-internal-common/static-1.31314",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6553",
      "crm_data": "/crm_data/static-4.92016",
      "customer-data-content": "/customer-data-content/static-1.27312",
      "draft-content-plugins": "/draft-content-plugins/static-1.28312",
      "draft-convert": "/draft-convert/static-2.73",
      "draft-extend": "/draft-extend/static-3.75",
      "draft-js": "/draft-js/static-5.78",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24114",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24402",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18266",
      "integration-settings-components": "/integration-settings-components/static-1.15517",
      "integrations-lib": "/integrations-lib/static-1.16200",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5612",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7793",
      "nav-meta": "/nav-meta/static-1.29717",
      "onboarding-scopes": "/onboarding-scopes/static-1.6473",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6244",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11660",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.38186",
      "react-colorpicker": "/react-colorpicker/static-2.10218",
      "reference-resolvers": "/reference-resolvers/static-1.8182",
      "rich-text-lib": "/rich-text-lib/static-1.19857",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3854",
      "sequences-lib": "/sequences-lib/static-1.8065",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11160",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9069",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9066",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10176",
      "user-context": "/user-context/static-1.5117",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5740",
      "events-data-lib": "/events-data-lib/static-1.233",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22280",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13176",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4730",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4012",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6801",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.991",
      "onboarding-tours": "/onboarding-tours/static-1.16638",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13731",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21571",
      "calling-global-api": "/calling-global-api/static-1.64562",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65944",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58238",
      "commerce-products-lib": "/commerce-products-lib/static-1.9623",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3804",
      "external-options-client-types": "/external-options-client-types/static-1.4166",
      "google-libphonenumber": "/google-libphonenumber/static-1.38",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4230",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.643",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3698",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48799",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3972",
      "property-value-citations": "/property-value-citations/static-1.2218",
      "smart-property-lib": "/smart-property-lib/static-1.7146",
      "tiered-pricing": "/tiered-pricing/static-1.1249",
      "zustand": "/zustand/static-1.74",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11001",
      "video-components-external": "/video-components-external/static-1.11326",
      "batch-promise": "/batch-promise/static-1.1553",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4146",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.15",
      "persist-promise": "/persist-promise/static-1.3710",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25428",
      "knowledge-content-types": "/knowledge-content-types/static-1.8483",
      "payment-link-components": "/payment-link-components/static-1.23587",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9899",
      "call-summary": "/call-summary/static-1.39252",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10144",
      "laboratory-lib": "/laboratory-lib/static-3.7167",
      "merchandise-lib": "/merchandise-lib/static-1.264",
      "purchase-motions-components": "/purchase-motions-components/static-1.5927",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9603",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.788",
      "content-icons-ui": "/content-icons-ui/static-1.2229",
      "social-insights-client-types": "/social-insights-client-types/static-1.22162",
      "outpost": "/outpost/static-1.4193",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4824",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5559",
      "magpie-types": "/magpie-types/static-1.5019",
      "simple-logging-lib": "/simple-logging-lib/static-1.3062",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6592",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46063",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16264",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4268",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19121",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18581",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10419",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.89",
      "directed-graph": "/directed-graph/static-1.947",
      "event-emitter": "/event-emitter/static-1.959",
      "fast-json-patch": "/fast-json-patch/static-1.63",
      "customer-data-associations": "/customer-data-associations/static-1.7337",
      "reporting-data": "/reporting-data/static-1.67612",
      "tanstack-virtual": "/tanstack-virtual/static-1.30",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4774",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3604",
      "self-service-api": "/self-service-api/static-1.10259",
      "crm_universal": "/crm_universal/static-1.22031",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9268",
      "content-embed-lib": "/content-embed-lib/static-1.7350",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12399",
      "remote-ui": "/remote-ui/static-1.65",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5620",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17052",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3024",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13615",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10377",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.506",
      "messaging-types-lib": "/messaging-types-lib/static-1.46062",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8232",
      "copilot-plugins": "/copilot-plugins/static-1.11146",
      "data-token-picker": "/data-token-picker/static-1.16431",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7922",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5445",
      "navigation-messaging": "/navigation-messaging/static-1.7407",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18507",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17625",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.704",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1187",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.8899",
      "growth-data-modal": "/growth-data-modal/static-1.5448",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3078",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1968",
      "navigation-components": "/navigation-components/static-1.18080",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4852",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7557",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11048",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1025",
      "commerce-permissions": "/commerce-permissions/static-1.781",
      "products-iframe-lib": "/products-iframe-lib/static-1.7982",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10380",
      "data-agent-kit": "/data-agent-kit/static-1.213",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10081",
      "fsm": "/fsm/static-1.3742",
      "policy-lib": "/policy-lib/static-1.6789",
      "react-tinymce": "/react-tinymce/static-1.55289",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54415",
      "tinymce-plugins": "/tinymce-plugins/static-1.57529",
      "tinymce-themes": "/tinymce-themes/static-1.56385",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12369",
      "content-media-compositions": "/content-media-compositions/static-2.16376",
      "idb-keyval": "/idb-keyval/static-1.44",
      "media-bridge-lib": "/media-bridge-lib/static-1.18950",
      "seat-types-lib": "/seat-types-lib/static-1.46",
      "ui-addon-opt": "/ui-addon-opt/static-4.8378",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6127",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5094",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3652",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19298",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8747",
      "purchase-motions-api": "/purchase-motions-api/static-1.5930",
      "trials-service-types": "/trials-service-types/static-1.3914",
      "reactive-lib": "/reactive-lib/static-1.736",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37223",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39592",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12112",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54779",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21516",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17906",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72096",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8962",
      "utility-belt": "/utility-belt/static-1.2546",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22945",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7529",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5755",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14859",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5120",
      "qrcode-generator": "/qrcode-generator/static-1.69",
      "reporting-client-types": "/reporting-client-types/static-1.2499",
      "react-flip-move": "/react-flip-move/static-1.70",
      "FireAlarmUi": "/FireAlarmUi/static-1.4520",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4177",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11051",
      "association-settings-lib": "/association-settings-lib/static-1.10330",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57872",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12478",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12659",
      "ExportDialog": "/ExportDialog/static-6.10399",
      "final-form": "/final-form/static-1.70",
      "html-to-image": "/html-to-image/static-1.54",
      "nudge-client-utils": "/nudge-client-utils/static-1.2613",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7113",
      "property-management-iframe": "/property-management-iframe/static-1.13206",
      "property-usages-lib": "/property-usages-lib/static-1.5451",
      "reactflow": "/reactflow/static-1.64",
      "simple-data-table": "/simple-data-table/static-1.2827",
      "used-in-list-lib": "/used-in-list-lib/static-1.6968",
      "visual-association": "/visual-association/static-1.5894",
      "highcharts": "/highcharts/static-8.104",
      "reporting-visualizations": "/reporting-visualizations/static-1.59688",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3935",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.288",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.413",
      "slack-ui-library": "/slack-ui-library/static-1.10404",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
      "ContentData": "/ContentData/static-1.68488",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.989",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1919",
      "ai-rendering-library": "/ai-rendering-library/static-1.10231",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7905",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.703",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15332",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.636",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.806",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.387",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6869",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3979",
      "ui-tool-access": "/ui-tool-access/static-1.10159",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1977",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1996",
      "user-context-client": "/user-context-client/static-1.4624",
      "nest": "/nest/static-1.239",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35802",
      "sales-views-client-types": "/sales-views-client-types/static-1.4270",
      "trellis-story-utils": "/trellis-story-utils/static-1.4527",
      "storybook-react": "/storybook-react/static-1.33",
      "hub-http-contrib": "/hub-http-contrib/static-1.3054",
      "interframe": "/interframe/static-3.4771",
      "tinymce-data": "/tinymce-data/static-1.40500",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5222",
      "codemirror": "/codemirror/static-5.95",
      "layout-dnd-components": "/layout-dnd-components/static-1.12470",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11445",
      "react-codemirror": "/react-codemirror/static-1.10638",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9066",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40141",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7086",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54795",
      "commerce-products-api": "/commerce-products-api/static-1.2314",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56853",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102774",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80817",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7677",
      "reporting-ui-components": "/reporting-ui-components/static-2.64883",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14950",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18302",
      "stripe-connect-js": "/stripe-connect-js/static-1.69",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9553",
      "nested-table": "/nested-table/static-1.238",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21389",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2669",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5896",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2370",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2689",
      "whisper-core-api": "/whisper-core-api/static-1.6669",
      "property-management-common": "/property-management-common/static-1.5494",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15147",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12086",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34093",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.60",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14392",
      "highlight.js": "/highlight.js/static-1.79",
      "reporting-action-components": "/reporting-action-components/static-1.41345",
      "reporting-snowflake": "/reporting-snowflake/static-1.56230",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7617",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9770",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.538",
      "price-books-api": "/price-books-api/static-1.798",
      "price-books-components": "/price-books-components/static-1.856",
      "property-description-translator": "/property-description-translator/static-1.3856",
      "ramp-editor": "/ramp-editor/static-1.183",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3640",
      "totals-ui-components": "/totals-ui-components/static-1.23646",
      "reporting-plugins": "/reporting-plugins/static-1.10343",
      "reporting-reports": "/reporting-reports/static-1.67290",
      "edison-service-client-types": "/edison-service-client-types/static-1.399",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10521",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17176",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19769",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8010",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.184",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15146",
      "simple-menus-lib": "/simple-menus-lib/static-1.16663",
      "academy-common-lib": "/academy-common-lib/static-1.13852",
      "dashboard-lib": "/dashboard-lib/static-1.81590",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8713",
      "line-items-api": "/line-items-api/static-1.714",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3826",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9167",
      "apps-service-types": "/apps-service-types/static-1.3889",
      "oauth-service-types": "/oauth-service-types/static-1.4260",
      "academy-service-client": "/academy-service-client/static-1.3692",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7162",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29335",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};